module.exports = __webpack_public_path__ + "img/transacoes.0cf9fa0d.svg";